import { z } from 'zod';
import { idnoSchema } from './domain';

export const entityStatusSchema = z.enum(['ACTIV', 'INACTIV', 'RADIAT', 'SUSPENDAT', 'UNKNOWN', 'UNAVAILABLE']);
export type EntityStatus = z.infer<typeof entityStatusSchema>;

export const lookupSourceSchema = z.enum(['LIVE', 'CACHE', 'FAKE', 'FALLBACK']);
export type LookupSource = z.infer<typeof lookupSourceSchema>;

export const lookupEntityRequestSchema = z.object({
  idno: idnoSchema,
});
export type LookupEntityRequest = z.infer<typeof lookupEntityRequestSchema>;

export const entityInfoSchema = z.object({
  found: z.boolean(),
  idno: z.string(),
  name: z.string(),
  status: entityStatusSchema,
  juridicalAddress: z.string(),
  registeredAt: z.string(),
  source: lookupSourceSchema,
});
export type EntityInfo = z.infer<typeof entityInfoSchema>;
